__turbopack_context__.v({
  "container": "index-module__JCOtCa__container",
  "content_wrapper": "index-module__JCOtCa__content_wrapper",
  "header": "index-module__JCOtCa__header",
  "leftSpan": "index-module__JCOtCa__leftSpan",
  "left_side": "index-module__JCOtCa__left_side",
  "right_side": "index-module__JCOtCa__right_side",
});
